import Promise from 'promise';

import { axios } from '../_helpers';

export const SMSCourseService = {
    getAllSMSCourses
};

function getAllSMSCourses() {
    return axios.get('api/smscourse/getAllSMSCourses').then((response) => {
        return response.data;
    }).catch((error) => {
        return Promise.reject(error);
    });
};



// WEBPACK FOOTER //
// ./src/_services/sms-course.service.js